import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotesHoverService {
  noteHover$ = new Subject<string>();
  noteOut$ = new Subject<string>();

  constructor() { }
}